import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './infoBox.html' with { type: 'html' };

export default {
	name: 'CInfoBox',
	components: {
		cSvg
	},
	props: {
		isSmall: {
			type: Boolean,
			default: false
		},
		isSmallest: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			required: true
		},
		svg: {
			type: String,
			default: '#infobox-icon'
		}
	},
	template
};
